import React from 'react';
import { css } from '@emotion/react';
import Navigation from '../navigation';
import BottomTabs from '../navigation/BottomTabs';
import { useLocation } from 'react-router-dom';
import { useAppContext } from 'contexts/AppContext';

const Footer = () => {
  const location = useLocation();
  const { getUserInfo } = useAppContext();
  const isCustomer = getUserInfo();
  return (
    <footer>
      {isCustomer && (
        <nav>
          <Navigation name={location.pathname.split('/')[1]} />
          {/*<BottomTabs />*/}
        </nav>
      )}
    </footer>
  );
};

export default Footer;
